import { Component, OnInit } from '@angular/core';
import { check24WwwOrigin } from '../../config/check24-environment';

@Component({
  selector: 'app-info-page',
  templateUrl: './info-page.component.html',
  styleUrls: ['./info-page.component.scss']
})
export class InfoPageComponent implements OnInit {

  public benefit = [
    {
      "title": "KSV neutral",
      "text": "Wenn Sie einen Kredit nehmen wollen, wird eine Bonitätsprüfung gemacht (bei KSV oder CRIF). Banken benötigen das als Sicherheit um möglichst sicher zu gehen, dass Sie die Kreditraten bezahlen können. Ihre Bonität wird anhand bestimmter Kriterien, wie zum Beispiel dem Einkommen, bewertet. Jede Bank hat eigene Regeln, was die Kreditwürdigkeit betrifft. Deshalb kann es sein, dass Sie bei der einen Bank abgelehnt werden, eine andere Ihnen aber ein Kreditangebot macht. Ein Kreditvergleich bei CHECK24 bringt somit 2 Vorteile. Sie wissen mit einer einzigen Anfrage welche Banken passende Angebote für Sie haben und Ihre Kreditwürdigkeit bleibt unverändert, egal wie oft Sie anfragen. Mehrere Kreditanfragen in einem bestimmten Zeitraum, direkt bei unterschiedlichen Banken können Ihre Bonität nämlich negativ beeinflussen."
    },
    {
      "title": "100% sicher",
      "text": "Kredite, die Sie bei uns online abschließen, sind garantiert genauso sicher wie Darlehen, die in einer Bankfiliale aufgenommen werden. Alle Daten, die CHECK24 von Ihnen benötigt, sind für die Kreditvergabe unabdingbar und werden etwa zur Bonitätsprüfung herangezogen. Die Informationen unterliegen bezüglich Datenerhebung, -speicherung und -verarbeitung den gesetzlichen Vorgaben der EU-Datenschutz-Grundverordnung und des österreichischen Datenschutzgesetzes."
    },
    {
      "title": "Bequem von zu Hause",
      "text": "Sie können Ihren Kredit von der Übermittlung der relevanten Unterlagen bis hin zum Identifizierungsnachweis und der Online-Signatur über den CHECK24 Kreditvergleich zu 100% digital abschließen. Bei allen Schritten sind der Schutz und die Sicherheit Ihrer Daten im Internet gewährleistet."
    },
    {
      "title": "CHECK24 Transparenz",
      "text": "Ob Zinssatz, monatliche Rate oder auch Kundenbewertungen - die Angebote werden übersichtlich dargestellt. Zusätzlich bekommen Sie per Klick auch alle Detailinformationen, die Sie für Ihre Entscheidung brauchen."
    }
  ]

  constructor() { }

  ngOnInit(): void {
  }

  openAccordion(event: Event): void {
    const element = event.currentTarget as HTMLElement | null;
    if (!element) {
      return;
    }
    element.classList.toggle('active');
    const arrow = element.querySelector('.arrow');
    arrow?.classList.toggle('up');
    arrow?.classList.toggle('down');
    const panel = element.nextElementSibling as HTMLElement | null;
    if (!panel) {
      return;
    }
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  }

  redirectPath(): void{
    const previousUrl = window.location.href;
    const path = previousUrl.split('/');
    const resultpage = path.includes('kreditcenter');
    if (resultpage) {
      window.location.href = `${check24WwwOrigin()}/kredit`;
    }
  }
}
